import { Grid } from '@mui/material';
import React from 'react';

type Props = {
  children: React.ReactNode;
};

const BlockImages = (props: Props) => (
  <Grid container className="block-images">
    {props.children}
  </Grid>
);

export default BlockImages;
